import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { firstValueFrom } from 'rxjs';
import { CsrWebApiService } from '../../../../csr-web-api.service';
import { CareerChallengeParticipantResponse } from '../../../../models';

@Component({
  selector: 'app-career-challenge-participants-tab',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatCardModule, MatFormFieldModule, MatInputModule, MatPaginatorModule, MatProgressBarModule],
  templateUrl: './participants-tab.component.html',
  styleUrl: './tab-shared.scss'
})
export class CareerChallengeParticipantsTabComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly api = inject(CsrWebApiService);
  private requestId = 0;
  participants: CareerChallengeParticipantResponse[] = [];
  totalCount = 0;
  search = '';
  pageIndex = 0;
  pageSize = 25;
  loading = false;
  error = '';

  ngOnInit(): void { void this.load(); }

  find(): void { this.pageIndex = 0; void this.load(); }

  changePage(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    void this.load();
  }

  async load(): Promise<void> {
    const requestId = ++this.requestId;
    this.loading = true;
    this.error = '';
    try {
      const id = this.route.parent?.snapshot.paramMap.get('id') ?? '';
      const result = await firstValueFrom(this.api.listAdminCareerChallengeParticipants(id, this.search.trim(), this.pageIndex + 1, this.pageSize));
      if (requestId !== this.requestId) return;
      this.participants = result.items;
      this.totalCount = result.totalCount;
    } catch {
      if (requestId !== this.requestId) return;
      this.participants = [];
      this.totalCount = 0;
      this.error = 'Could not load participants. Please try again.';
    } finally {
      if (requestId === this.requestId) this.loading = false;
    }
  }
}
